import React from 'react';
import { Portal } from '@chakra-ui/react';
import NewAudience from 'scenes/audiences/NewAudience';

function CreateAudienceModal({
  isModalOpen,
  onModalClose,
  audienceId,
  onUpdateAudience,
}) {
  if (!isModalOpen) return null;

  return (
    <Portal>
      <NewAudience
        audienceId={audienceId}
        onModalClose={onModalClose}
        onUpdateAudience={onUpdateAudience}
      />
    </Portal>
  );
}

export default CreateAudienceModal;
